import { ThemeConfig } from 'src/common/config'

export const calcMarginRight = (): number => ThemeConfig.spacing.l * 4.64
